
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test/catalog_search_improvements/variant_b/catalog",
      function () {
        return require("private-next-pages/test/catalog_search_improvements/variant_b/catalog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test/catalog_search_improvements/variant_b/catalog"])
      });
    }
  